import { Typography } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'

export const PriceBox = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
}))

export const PriceText = styled(Typography)(({ theme }) => ({
  color: theme.colors.grey[900],
  fontWeight: 500,
  fontSize: '1.5rem',
  lineHeight: 1.6,
  position: 'relative',
  marginBottom: '1px',
  '&::after': {
    content: '""',
    position: 'absolute',
    top: '50%',
    left: 0,
    height: '2px',
    width: '100%',
    backgroundColor: theme.colors.sky[700],
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '1.25rem',
  },
}))

export const FreeText = styled(Typography)(({ theme }) => ({
  color: theme.colors.blue[900],
  fontWeight: 700,
  fontSize: '1.75rem',
  lineHeight: '40px',
  [theme.breakpoints.up('md')]: {
    fontSize: '1.375rem',
    lineHeight: 1.2,
  },
}))
